import React from "react";

const Feed = () => {
  return (
    <div className="feedTabContainer">
      <h2>Information Hub</h2>
      {[
        require("../../../../../assets/images/article-one.png"),
        require("../../../../../assets/images/article-two.png"),
        require("../../../../../assets/images/article-three.png"),
      ].map((v, i) => {
        return <img src={v} key={i} />;
      })}
    </div>
  );
};

export default Feed;
